import Link from 'next/link';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import logoColor from '../../images/TravelFeed-logo-horizontal-color.svg';
import { INK, TfMark } from './ui';

const NAV_LINKS = [
  { label: 'Features', href: '#itinerary' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Explore stories', href: '/explore' },
];

export default function LandingNav({ onJoin, onLogin, links = NAV_LINKS }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`tw-fixed tw-inset-x-0 tw-top-0 tw-z-50 tw-transition-[background-color,box-shadow] tw-duration-300 ${
        scrolled
          ? 'tw-bg-[rgba(250,248,241,0.85)] dark:tw-bg-[rgba(14,26,22,0.85)] tw-backdrop-blur-md tw-shadow-[0_1px_0_0_rgba(29,45,40,0.08)] dark:tw-shadow-[0_1px_0_0_rgba(255,255,255,0.06)]'
          : 'tw-bg-transparent'
      }`}
    >
      <nav className="tw-mx-auto tw-flex tw-h-16 tw-max-w-7xl tw-items-center tw-justify-between tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <Link
          href="/"
          className="tw-flex tw-items-center tw-no-underline"
          aria-label="TravelFeed"
        >
          {/* Below xs the wordmark collides with the buttons — square mark only */}
          <TfMark className="tw-block xs:tw-hidden tw-h-7 tw-w-auto tw-text-primary-600 dark:tw-text-white" />
          <Image
            src={logoColor}
            alt="TravelFeed"
            className="tw-hidden xs:tw-block tw-h-6 tw-w-auto sm:tw-h-7 dark:tw-hidden"
            priority
          />
          <Image
            src="/header-logo.svg"
            alt="TravelFeed"
            width={162}
            height={28}
            className="tw-hidden dark:xs:tw-block tw-h-6 tw-w-auto sm:tw-h-7"
            priority
          />
        </Link>
        <div className="tw-hidden tw-items-center tw-gap-8 lg:tw-flex">
          {links.map(link => {
            const linkClassName = `${INK} tw-text-[15px] tw-font-medium tw-no-underline hover:tw-text-primary-700 dark:hover:tw-text-primary-300 tw-transition-colors`;
            // Same-page hash anchors keep a plain <a>; everything else gets
            // client-side navigation.
            return link.href.startsWith('#') ? (
              <a key={link.label} href={link.href} className={linkClassName}>
                {link.label}
              </a>
            ) : (
              <Link key={link.label} href={link.href} className={linkClassName}>
                {link.label}
              </Link>
            );
          })}
        </div>
        <div className="tw-flex tw-items-center tw-gap-1 sm:tw-gap-3">
          <button
            type="button"
            onClick={onLogin}
            className={`${INK} tw-cursor-pointer tw-whitespace-nowrap tw-border-0 tw-bg-transparent tw-px-2 tw-py-2 tw-text-sm tw-font-medium tw-transition-colors hover:tw-text-primary-700 dark:hover:tw-text-primary-300 sm:tw-px-3 sm:tw-text-[15px]`}
          >
            Log in
          </button>
          <button
            type="button"
            onClick={onJoin}
            className="tw-cursor-pointer tw-whitespace-nowrap tw-rounded-full tw-border-0 tw-bg-primary-600 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-[0_6px_20px_-8px_rgba(0,137,123,0.8)] tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-bg-primary-700 sm:tw-px-5 sm:tw-py-2.5 sm:tw-text-[15px]"
          >
            Start your blog
          </button>
        </div>
      </nav>
    </header>
  );
}
